const HeaderSubmenu = {
	init() {
		this.bindEvents();
	},

	bindEvents() {
		const menuItems = document.querySelectorAll('.nav-items .menu-item-has-children');
		
		menuItems.forEach(item => {
			const submenu = item.querySelector('.sub-menu');
			
			if (!submenu) return;

			let timeoutId = null;

			item.addEventListener('mouseenter', () => {
				if (timeoutId) {
					clearTimeout(timeoutId);
					timeoutId = null;
				}
				submenu.classList.add('active');
			});

			item.parentElement.addEventListener('mouseleave', () => {
				timeoutId = setTimeout(() => {
					submenu.classList.remove('active');
				}, 100);
			});
		});
	}
};

export default HeaderSubmenu;
